import { useCallback, useMemo } from 'react';
import type { ISecodaEditor, MenuItem } from '../..';
import dictionary from '../../dictionary';
import getMenuItems from '../../menus/block';
import { Toolbar } from '../../types';
import { CommandMenu } from './CommandMenu';
import { CommandMenuItem } from './CommandMenuItem';

export function BlockMenu({ editor }: { editor: ISecodaEditor }) {
	const items = useMemo(() => {
		const allItems: Array<MenuItem> = getMenuItems(
			dictionary,
			!!editor.options.template
		);

		const embedsItems = (editor.options.embeds ?? [])
			.filter((embed) => embed.title && embed.icon)
			.map((embed) => ({ ...embed, name: 'embed' }));

		if (embedsItems.length > 0) {
			allItems.push({ name: 'separator' });
			allItems.push(...embedsItems);
		}

		return allItems;
	}, [editor.options.embeds, editor.options.template]);

	const renderMenuItem = useCallback(
		(item: MenuItem, _index: number, options: Record<string, unknown>) => (
			<CommandMenuItem
				key={_index}
				icon={item.icon}
				shortcutKeys={item.shortcutKeys}
				{...options}
			>
				{item.title}
			</CommandMenuItem>
		),
		[]
	);

	return (
		<CommandMenu
			editor={editor}
			search={editor.blockMenuSearch ?? ''}
			id="block-menu-container"
			trigger="/"
			filterable
			renderMenuItem={renderMenuItem}
			items={items}
			toolbar={Toolbar.BlockMenu}
		/>
	);
}
